import createAction from '../../common/services/create-action.js';

export const UPDATE_CATEGORIES = 'UPDATE_CATEGORIES';
export const updateCategories = createAction(
  UPDATE_CATEGORIES,
  payload => payload,
  (payload, meta) => meta,
);
